import * as React from 'react';
import TableHeader from '../TableHeader';
import { default as DispatchProps, mapDispatchToProps } from '../../application/core/DispatchProps';
import UserEstimationModel from '../../domain/UserEstimation';
import { connect } from 'react-redux';
import State from '../../application/core/State';
import UserEstimation from './UserEstimation';
import UserEstimationsRequested from '../../application/estimations/events/UserEstimationsRequested';

interface StateProps {
    userEstimations: UserEstimationModel[];
    customerId: string;
}

class UserEstimations extends React.PureComponent<StateProps & DispatchProps> {
    public componentDidMount(): void {
        this.props.dispatch(new UserEstimationsRequested());
    }

    public render(): JSX.Element {
        const headers = ['Estimation #', 'Date of estimation', 'QTY', 'Total', 'Delivery drop'];
        return (
            <div className="card-container">
                <h1 className="card-header">MY ESTIMATIONS</h1>
                <div className="card">
                    <TableHeader headers={headers} class="user-orders-header" />
                    {this.props.userEstimations.map(estimation => (
                        <UserEstimation userEstimations={estimation} customerId={this.props.customerId} link={this.estimationLink} />
                    ))}
                </div>
            </div>
        );
    }

    private estimationLink = (estimationId: number): string => `/estimations/${estimationId}`;
}

const mapStateToProps = (state: State): StateProps => ({
    userEstimations: state.userEstimations,
    customerId: state.user.customerId
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UserEstimations);



// WEBPACK FOOTER //
// ./src/view/estimations/UserEstimations.tsx